import _defineProperty from "/builds/elproag/cloud/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { genBasicInputStyle, genInputSmallStyle, initComponentToken, initInputToken } from '../../input/style';
import { genFocusOutline, genFocusStyle, resetComponent } from '../../style';
import { genComponentStyleHook, mergeToken } from '../../theme/internal';
var genPaginationDisabledStyle = function genPaginationDisabledStyle(token) {
  var _$concat$concat, _$concat2, _ref;
  var componentCls = token.componentCls;
  return _ref = {}, _defineProperty(_ref, "".concat(componentCls, "-disabled"), {
    '&, &:hover': _defineProperty({
      cursor: 'not-allowed'
    }, "".concat(componentCls, "-item-link"), {
      color: token.colorTextDisabled,
      cursor: 'not-allowed'
    }),
    '&:focus-visible': _defineProperty({
      cursor: 'not-allowed'
    }, "".concat(componentCls, "-item-link"), {
      color: token.colorTextDisabled,
      cursor: 'not-allowed'
    })
  }), _defineProperty(_ref, "&".concat(componentCls, "-disabled"), (_$concat2 = {
    cursor: 'not-allowed'
  }, _defineProperty(_$concat2, "".concat(componentCls, "-item"), {
    cursor: 'not-allowed',
    '&:hover, &:active': {
      backgroundColor: 'transparent'
    },
    a: {
      color: token.colorTextDisabled,
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'not-allowed'
    },
    '&-active': {
      borderColor: token.colorBorder,
      backgroundColor: token.itemActiveBgDisabled,
      '&:hover, &:active': {
        backgroundColor: token.itemActiveBgDisabled
      },
      a: {
        color: token.itemActiveColorDisabled
      }
    }
  }), _defineProperty(_$concat2, "".concat(componentCls, "-item-link"), _defineProperty({
    color: token.colorTextDisabled,
    cursor: 'not-allowed',
    '&:hover, &:active': {
      backgroundColor: 'transparent'
    }
  }, "".concat(componentCls, "-simple&"), {
    backgroundColor: 'transparent',
    '&:hover, &:active': {
      backgroundColor: 'transparent'
    }
  })), _defineProperty(_$concat2, "".concat(componentCls, "-simple-pager"), {
    color: token.colorTextDisabled
  }), _defineProperty(_$concat2, "".concat(componentCls, "-jump-prev, ").concat(componentCls, "-jump-next"), (_$concat$concat = {}, _defineProperty(_$concat$concat, "".concat(componentCls, "-item-link-icon"), {
    opacity: 0
  }), _defineProperty(_$concat$concat, "".concat(componentCls, "-item-ellipsis"), {
    opacity: 1
  }), _$concat$concat)), _$concat2)), _defineProperty(_ref, "&".concat(componentCls, "-simple"), _defineProperty({}, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), _defineProperty({}, "&".concat(componentCls, "-disabled ").concat(componentCls, "-item-link"), {
    '&:hover, &:active': {
      backgroundColor: 'transparent'
    }
  }))), _ref;
};
var genPaginationMiniStyle = function genPaginationMiniStyle(token) {
  var _$concat$concat3, _$concat$concat5, _ref2;
  var componentCls = token.componentCls;
  return _ref2 = {}, _defineProperty(_ref2, "&".concat(componentCls, "-mini ").concat(componentCls, "-total-text, &").concat(componentCls, "-mini ").concat(componentCls, "-simple-pager"), {
    height: token.itemSizeSM,
    lineHeight: "".concat(token.itemSizeSM, "px")
  }), _defineProperty(_ref2, "&".concat(componentCls, "-mini ").concat(componentCls, "-item"), {
    minWidth: token.itemSizeSM,
    height: token.itemSizeSM,
    margin: 0,
    lineHeight: "".concat(token.itemSizeSM - 2, "px")
  }), _defineProperty(_ref2, "&".concat(componentCls, "-mini:not(").concat(componentCls, "-disabled) ").concat(componentCls, "-item:not(").concat(componentCls, "-item-active)"), {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    '&:hover': {
      backgroundColor: token.colorBgTextHover
    },
    '&:active': {
      backgroundColor: token.colorBgTextActive
    }
  }), _defineProperty(_ref2, "&".concat(componentCls, "-mini ").concat(componentCls, "-prev, &").concat(componentCls, "-mini ").concat(componentCls, "-next"), {
    minWidth: token.itemSizeSM,
    height: token.itemSizeSM,
    margin: 0,
    lineHeight: "".concat(token.itemSizeSM, "px")
  }), _defineProperty(_ref2, "&".concat(componentCls, "-mini:not(").concat(componentCls, "-disabled)"), _defineProperty({}, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), (_$concat$concat3 = {}, _defineProperty(_$concat$concat3, "&:hover ".concat(componentCls, "-item-link"), {
    backgroundColor: token.colorBgTextHover
  }), _defineProperty(_$concat$concat3, "&:active ".concat(componentCls, "-item-link"), {
    backgroundColor: token.colorBgTextActive
  }), _defineProperty(_$concat$concat3, "&".concat(componentCls, "-disabled:hover ").concat(componentCls, "-item-link"), {
    backgroundColor: 'transparent'
  }), _$concat$concat3))), _defineProperty(_ref2, "\n    &".concat(componentCls, "-mini ").concat(componentCls, "-prev ").concat(componentCls, "-item-link,\n    &").concat(componentCls, "-mini ").concat(componentCls, "-next ").concat(componentCls, "-item-link\n    "), {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    '&::after': {
      height: token.itemSizeSM,
      lineHeight: "".concat(token.itemSizeSM, "px")
    }
  }), _defineProperty(_ref2, "&".concat(componentCls, "-mini ").concat(componentCls, "-jump-prev, &").concat(componentCls, "-mini ").concat(componentCls, "-jump-next"), {
    height: token.itemSizeSM,
    marginInlineEnd: 0,
    lineHeight: "".concat(token.itemSizeSM, "px")
  }), _defineProperty(_ref2, "&".concat(componentCls, "-mini ").concat(componentCls, "-options"), (_$concat$concat5 = {
    marginInlineStart: token.paginationMiniOptionsMarginInlineStart
  }, _defineProperty(_$concat$concat5, "&-size-changer", {
    top: token.miniOptionsSizeChangerTop
  }), _defineProperty(_$concat$concat5, "&-quick-jumper", {
    height: token.itemSizeSM,
    lineHeight: "".concat(token.itemSizeSM, "px"),
    input: Object.assign(Object.assign({}, genInputSmallStyle(token)), {
      width: token.paginationMiniQuickJumperInputWidth,
      height: token.controlHeightSM
    })
  }), _$concat$concat5)), _ref2;
};
var genPaginationSimpleStyle = function genPaginationSimpleStyle(token) {
  var _ref3;
  var componentCls = token.componentCls;
  return _ref3 = {}, _defineProperty(_ref3, "\n    &".concat(componentCls, "-simple ").concat(componentCls, "-prev,\n    &").concat(componentCls, "-simple ").concat(componentCls, "-next\n    "), _defineProperty({
    height: token.itemSizeSM,
    lineHeight: "".concat(token.itemSizeSM, "px"),
    verticalAlign: 'top'
  }, "".concat(componentCls, "-item-link"), {
    height: token.itemSizeSM,
    backgroundColor: 'transparent',
    border: 0,
    '&:hover': {
      backgroundColor: token.colorBgTextHover
    },
    '&:active': {
      backgroundColor: token.colorBgTextActive
    },
    '&::after': {
      height: token.itemSizeSM,
      lineHeight: "".concat(token.itemSizeSM, "px")
    }
  })), _defineProperty(_ref3, "&".concat(componentCls, "-simple ").concat(componentCls, "-simple-pager"), {
    display: 'inline-block',
    height: token.itemSizeSM,
    marginInlineEnd: token.marginXS,
    input: {
      boxSizing: 'border-box',
      height: '100%',
      marginInlineEnd: token.marginXS,
      padding: "0 ".concat(token.paginationItemPaddingInline, "px"),
      textAlign: 'center',
      backgroundColor: token.itemInputBg,
      border: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorBorder),
      borderRadius: token.borderRadius,
      outline: 'none',
      transition: "border-color ".concat(token.motionDurationMid),
      color: 'inherit',
      '&:hover': {
        borderColor: token.colorPrimary
      },
      '&:focus': {
        borderColor: token.colorPrimaryHover,
        boxShadow: "".concat(token.inputOutlineOffset, "px 0 ").concat(token.controlOutlineWidth, "px ").concat(token.controlOutline)
      },
      '&[disabled]': {
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        cursor: 'not-allowed'
      }
    }
  }), _ref3;
};
var genPaginationJumpStyle = function genPaginationJumpStyle(token) {
  var _$concat4, _hover2, _$concat$concat7, _$concat$concat8, _ref4;
  var componentCls = token.componentCls;
  return _ref4 = {}, _defineProperty(_ref4, "".concat(componentCls, "-jump-prev, ").concat(componentCls, "-jump-next"), (_$concat$concat7 = {
    outline: 0
  }, _defineProperty(_$concat$concat7, "".concat(componentCls, "-item-container"), (_$concat4 = {
    position: 'relative'
  }, _defineProperty(_$concat4, "".concat(componentCls, "-item-link-icon"), {
    color: token.colorPrimary,
    fontSize: token.fontSizeSM,
    opacity: 0,
    transition: "all ".concat(token.motionDurationMid),
    '&-svg': {
      top: 0,
      insetInlineEnd: 0,
      bottom: 0,
      insetInlineStart: 0,
      margin: 'auto'
    }
  }), _defineProperty(_$concat4, "".concat(componentCls, "-item-ellipsis"), {
    position: 'absolute',
    top: 0,
    insetInlineEnd: 0,
    bottom: 0,
    insetInlineStart: 0,
    display: 'block',
    margin: 'auto',
    color: token.colorTextDisabled,
    fontFamily: 'Arial, Helvetica, sans-serif',
    letterSpacing: token.paginationEllipsisLetterSpacing,
    textAlign: 'center',
    textIndent: token.paginationEllipsisTextIndent,
    opacity: 1,
    transition: "all ".concat(token.motionDurationMid)
  }), _$concat4)), _defineProperty(_$concat$concat7, '&:hover', (_hover2 = {}, _defineProperty(_hover2, "".concat(componentCls, "-item-link-icon"), {
    opacity: 1
  }), _defineProperty(_hover2, "".concat(componentCls, "-item-ellipsis"), {
    opacity: 0
  }), _hover2)), _$concat$concat7)), _defineProperty(_ref4, "\n    ".concat(componentCls, "-prev,\n    ").concat(componentCls, "-jump-prev,\n    ").concat(componentCls, "-jump-next\n    "), {
    marginInlineEnd: token.marginXS
  }), _defineProperty(_ref4, "\n    ".concat(componentCls, "-prev,\n    ").concat(componentCls, "-next,\n    ").concat(componentCls, "-jump-prev,\n    ").concat(componentCls, "-jump-next\n    "), {
    display: 'inline-block',
    minWidth: token.itemSize,
    height: token.itemSize,
    color: token.colorText,
    fontFamily: token.fontFamily,
    lineHeight: "".concat(token.itemSize, "px"),
    textAlign: 'center',
    verticalAlign: 'middle',
    listStyle: 'none',
    borderRadius: token.borderRadius,
    cursor: 'pointer',
    transition: "all ".concat(token.motionDurationMid)
  }), _defineProperty(_ref4, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), (_$concat$concat8 = {
    fontFamily: 'Arial, Helvetica, sans-serif',
    outline: 0,
    button: {
      color: token.colorText,
      cursor: 'pointer',
      userSelect: 'none'
    }
  }, _defineProperty(_$concat$concat8, "".concat(componentCls, "-item-link"), {
    display: 'block',
    width: '100%',
    height: '100%',
    padding: 0,
    fontSize: token.fontSizeSM,
    textAlign: 'center',
    backgroundColor: 'transparent',
    border: "".concat(token.lineWidth, "px ").concat(token.lineType, " transparent"),
    borderRadius: token.borderRadius,
    outline: 'none',
    transition: "all ".concat(token.motionDurationMid)
  }), _defineProperty(_$concat$concat8, "&:hover ".concat(componentCls, "-item-link"), {
    backgroundColor: token.colorBgTextHover
  }), _defineProperty(_$concat$concat8, "&:active ".concat(componentCls, "-item-link"), {
    backgroundColor: token.colorBgTextActive
  }), _defineProperty(_$concat$concat8, "&".concat(componentCls, "-disabled:hover"), _defineProperty({}, "".concat(componentCls, "-item-link"), {
    backgroundColor: 'transparent'
  })), _$concat$concat8)), _defineProperty(_ref4, "".concat(componentCls, "-slash"), {
    marginInlineEnd: token.paginationSlashMarginInlineEnd,
    marginInlineStart: token.paginationSlashMarginInlineStart
  }), _defineProperty(_ref4, "".concat(componentCls, "-options"), {
    display: 'inline-block',
    marginInlineStart: token.margin,
    verticalAlign: 'middle',
    '&-size-changer.-select': {
      display: 'inline-block',
      width: 'auto'
    },
    '&-quick-jumper': {
      display: 'inline-block',
      height: token.controlHeight,
      marginInlineStart: token.marginXS,
      lineHeight: "".concat(token.controlHeight, "px"),
      verticalAlign: 'top',
      input: Object.assign(Object.assign({}, genBasicInputStyle(token)), {
        width: token.controlHeightLG * 1.25,
        height: token.controlHeight,
        boxSizing: 'border-box',
        margin: 0,
        marginInlineStart: token.marginXS,
        marginInlineEnd: token.marginXS
      })
    }
  }), _ref4;
};
var genPaginationItemStyle = function genPaginationItemStyle(token) {
  var _$concat6;
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-item"), (_$concat6 = {
    display: 'inline-block',
    minWidth: token.itemSize,
    height: token.itemSize,
    marginInlineEnd: token.marginXS,
    fontFamily: token.fontFamily,
    lineHeight: "".concat(token.itemSize - 2, "px"),
    textAlign: 'center',
    verticalAlign: 'middle',
    listStyle: 'none',
    backgroundColor: 'transparent',
    border: "".concat(token.lineWidth, "px ").concat(token.lineType, " transparent"),
    borderRadius: token.borderRadius,
    outline: 0,
    cursor: 'pointer',
    userSelect: 'none',
    a: {
      display: 'block',
      padding: "0 ".concat(token.paginationItemPaddingInline, "px"),
      color: token.colorText,
      '&:hover': {
        textDecoration: 'none'
      }
    }
  }, _defineProperty(_$concat6, "&:not(".concat(componentCls, "-item-active)"), {
    '&:hover': {
      transition: "all ".concat(token.motionDurationMid),
      backgroundColor: token.colorBgTextHover
    },
    '&:active': {
      backgroundColor: token.colorBgTextActive
    }
  }), _defineProperty(_$concat6, '&-active', {
    fontWeight: token.fontWeightStrong,
    backgroundColor: token.itemActiveBg,
    borderColor: token.colorPrimary,
    a: {
      color: token.colorPrimary
    },
    '&:hover': {
      borderColor: token.colorPrimaryHover
    },
    '&:hover a': {
      color: token.colorPrimaryHover
    }
  }), _$concat6));
};
var genPaginationStyle = function genPaginationStyle(token) {
  var _Object$assign2, _ref6;
  var componentCls = token.componentCls;
  return _ref6 = {}, _defineProperty(_ref6, componentCls, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), _defineProperty({
    'ul, ol': {
      margin: 0,
      padding: 0,
      listStyle: 'none'
    },
    '&::after': {
      display: 'block',
      clear: 'both',
      height: 0,
      overflow: 'hidden',
      visibility: 'hidden',
      content: '""'
    }
  }, "".concat(componentCls, "-total-text"), {
    display: 'inline-block',
    height: token.itemSize,
    marginInlineEnd: token.marginXS,
    lineHeight: "".concat(token.itemSize - 2, "px"),
    verticalAlign: 'middle'
  })), genPaginationItemStyle(token)), genPaginationJumpStyle(token)), genPaginationSimpleStyle(token)), genPaginationMiniStyle(token)), genPaginationDisabledStyle(token)), (_Object$assign2 = {}, _defineProperty(_Object$assign2, "@media only screen and (max-width: ".concat(token.screenLG, "px)"), _defineProperty({}, "".concat(componentCls, "-item"), {
    '&-after-jump-prev, &-before-jump-next': {
      display: 'none'
    }
  })), _defineProperty(_Object$assign2, "@media only screen and (max-width: ".concat(token.screenSM, "px)"), _defineProperty({}, "".concat(componentCls, "-options"), {
    display: 'none'
  })), _Object$assign2))), _defineProperty(_ref6, "&".concat(token.componentCls, "-rtl"), {
    direction: 'rtl'
  }), _ref6;
};
var genBorderedStyle = function genBorderedStyle(token) {
  var _$concat$concat9, _$concat$concat$conca, _$concat$concat11, _$concat8, _$concat$concat12, _ref7;
  var componentCls = token.componentCls;
  return _ref7 = {}, _defineProperty(_ref7, "".concat(componentCls).concat(componentCls, "-disabled:not(").concat(componentCls, "-mini)"), (_$concat$concat$conca = {
    '&, &:hover': _defineProperty({}, "".concat(componentCls, "-item-link"), {
      borderColor: token.colorBorder
    }),
    '&:focus-visible': _defineProperty({}, "".concat(componentCls, "-item-link"), {
      borderColor: token.colorBorder
    })
  }, _defineProperty(_$concat$concat$conca, "".concat(componentCls, "-item, ").concat(componentCls, "-item-link"), (_$concat$concat9 = {
    backgroundColor: token.colorBgContainerDisabled,
    borderColor: token.colorBorder
  }, _defineProperty(_$concat$concat9, "&:hover:not(".concat(componentCls, "-item-active)"), {
    backgroundColor: token.colorBgContainerDisabled,
    borderColor: token.colorBorder,
    a: {
      color: token.colorTextDisabled
    }
  }), _defineProperty(_$concat$concat9, "&".concat(componentCls, "-item-active"), {
    backgroundColor: token.itemActiveBgDisabled
  }), _$concat$concat9)), _defineProperty(_$concat$concat$conca, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), _defineProperty({
    '&:hover button': {
      backgroundColor: token.colorBgContainerDisabled,
      borderColor: token.colorBorder,
      color: token.colorTextDisabled
    }
  }, "".concat(componentCls, "-item-link"), {
    backgroundColor: token.colorBgContainerDisabled,
    borderColor: token.colorBorder
  })), _$concat$concat$conca)), _defineProperty(_ref7, "".concat(componentCls, ":not(").concat(componentCls, "-mini)"), (_$concat$concat12 = {}, _defineProperty(_$concat$concat12, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), (_$concat$concat11 = {
    '&:hover button': {
      borderColor: token.colorPrimaryHover,
      backgroundColor: token.itemBg
    }
  }, _defineProperty(_$concat$concat11, "".concat(componentCls, "-item-link"), {
    backgroundColor: token.itemLinkBg,
    borderColor: token.colorBorder
  }), _defineProperty(_$concat$concat11, "&:hover ".concat(componentCls, "-item-link"), {
    borderColor: token.colorPrimary,
    backgroundColor: token.itemBg,
    color: token.colorPrimary
  }), _defineProperty(_$concat$concat11, "&".concat(componentCls, "-disabled"), _defineProperty({}, "".concat(componentCls, "-item-link"), {
    borderColor: token.colorBorder,
    color: token.colorTextDisabled
  })), _$concat$concat11)), _defineProperty(_$concat$concat12, "".concat(componentCls, "-item"), (_$concat8 = {
    backgroundColor: token.itemBg,
    border: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorBorder)
  }, _defineProperty(_$concat8, "&:hover:not(".concat(componentCls, "-item-active)"), {
    borderColor: token.colorPrimary,
    backgroundColor: token.itemBg,
    a: {
      color: token.colorPrimary
    }
  }), _defineProperty(_$concat8, '&-active', {
    borderColor: token.colorPrimary
  }), _$concat8)), _$concat$concat12)), _ref7;
};
var genPaginationFocusStyle = function genPaginationFocusStyle(token) {
  var _Object$assign3, _$concat$concat14;
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, ":not(").concat(componentCls, "-disabled)"), (_$concat$concat14 = {}, _defineProperty(_$concat$concat14, "".concat(componentCls, "-item"), Object.assign({}, genFocusStyle(token))), _defineProperty(_$concat$concat14, "".concat(componentCls, "-jump-prev, ").concat(componentCls, "-jump-next"), {
    '&:focus-visible': Object.assign((_Object$assign3 = {}, _defineProperty(_Object$assign3, "".concat(componentCls, "-item-link-icon"), {
      opacity: 1
    }), _defineProperty(_Object$assign3, "".concat(componentCls, "-item-ellipsis"), {
      opacity: 0
    }), _Object$assign3), genFocusOutline(token))
  }), _defineProperty(_$concat$concat14, "".concat(componentCls, "-prev, ").concat(componentCls, "-next"), _defineProperty({}, "&:focus-visible ".concat(componentCls, "-item-link"), Object.assign({}, genFocusOutline(token)))), _$concat$concat14));
};
// ============================== Export ==============================
export default genComponentStyleHook('Pagination', function (token) {
  var paginationToken = mergeToken(token, {
    inputOutlineOffset: 0,
    paginationMiniOptionsMarginInlineStart: token.marginXXS / 2,
    paginationMiniQuickJumperInputWidth: token.controlHeightLG * 1.1,
    paginationItemPaddingInline: token.marginXXS * 1.5,
    paginationEllipsisLetterSpacing: token.marginXXS / 2,
    paginationSlashMarginInlineStart: token.marginXXS,
    paginationSlashMarginInlineEnd: token.marginSM,
    paginationEllipsisTextIndent: '0.13em' // magic for ui experience
  }, initInputToken(token), initComponentToken(token));
  return [genPaginationStyle(paginationToken), genPaginationFocusStyle(paginationToken), token.wireframe && genBorderedStyle(paginationToken)];
}, function (token) {
  return {
    itemBg: token.colorBgContainer,
    itemSize: token.controlHeight,
    itemSizeSM: token.controlHeightSM,
    itemActiveBg: token.colorBgContainer,
    itemLinkBg: token.colorBgContainer,
    itemActiveColorDisabled: token.colorTextDisabled,
    itemActiveBgDisabled: token.controlItemBgActiveDisabled,
    itemInputBg: token.colorBgContainer,
    miniOptionsSizeChangerTop: 0
  };
});